<template>
    <div>
        <div>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">添加好友</div>
                    </van-col>
                    <van-col span="6">
                        <img @click="toQr" class="qr-code" src="@/assets/theme/light/share/01home/02qr.svg">
                    </van-col>
                </van-row>
            </div>
            <div class="no-friend">
                <img class="no-img" src="@/assets/theme/light/share/01home/05no.svg">
                <div class="no-text">邀请TA加入共享空间，分享健康和运动</div>
                <div class="no-sub-text">你需要至少选择一项数据与TA共享</div>
            </div>
            <div class="add-box">
                <div class="qr-box" @click="toQrAdd">
                    <img class="find-icon" src="@/assets/theme/light/share/03addFriend/01qr.png">
                    <div class="add-title">扫码添加</div>
                    <div class="add-sub-title">扫描对方共享空间二维码</div>
                </div>
                <div class="qr-box" @click="toPhone">
                    <img class="find-icon" src="@/assets/theme/light/share/03addFriend/03phone.png">
                    <div class="add-title">手机号添加</div>
                    <div class="add-sub-title">输入对方手机号</div>
                </div>
                <div class="qr-box" @click="toFind">
                    <img class="find-icon" src="@/assets/theme/light/share/03addFriend/02search.png">
                    <div class="add-title">搜索添加</div>
                    <div class="add-sub-title">发现更多北斗好友</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant';
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'addFriend',
        data() {
            return {
                theme: 'light'
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            window.setScanResult = this.setScanResult;
        },
        methods: {
            back() {
                this.$router.back();
            },
            toQr() {
                this.$router.push({
                    name: 'myQrLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toQrAdd() {
                // this.$router.push({
                //     name: 'qrAdd'
                // })
                WebJSBridge.call("openScanCode", null, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            setScanResult(result){
                console.log(result);
                this.$api.share.findMembers({
                    sharerId: result
                }).then(res => {
                    let user = res.info;
                    localStorage.setItem("addUser", JSON.stringify(user));
                    this.$router.push({
                        name: 'confirmLight',
                        params: {
                            type: 'qr'
                        },
                        query: {
                            theme: this.theme
                        }
                    })
                }).catch(e => {
                    this.$router.push({
                        name: 'qrResultLight',
                        params: {
                            result: this.result
                        },
                        query: {
                            theme: this.theme
                        }
                    })
                })
            },
            toPhone() {
                this.$router.push({
                    name: 'phoneLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toFind() {
                this.$router.push({
                    name: 'findLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .qr-code {
        width: 22px;
        height: 22px;
        margin: 11px 15px 11px 10px;
        float: right;
    }

    .no-friend {
        text-align: center;
    }

    .no-img {
        width: 259px;
        margin-top: 20px;
    }

    .no-text {
        margin-top: 20px;
        font-size: 15px;
        color: var(--text-color-1);
        margin-bottom: 8px;
    }

    .no-sub-text {
        font-size: 12px;
        color: var(--text-color-2);
    }

    .add-box {
        margin-top: 47px;
    }

    .qr-box {
        width: 339px;
        position: relative;
        height: 68px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 0 auto 15px;
    }

    .find-icon {
        width: 42px;
        position: absolute;
        top: 13px;
        right: 24px;
    }

    .add-title {
        position: absolute;
        top: 15px;
        left: 22px;
        font-size: 15px;
        color: var(--text-color-1);
    }

    .add-sub-title {
        position: absolute;
        top: 39px;
        left: 22px;
        font-size: 12px;
        color: var(--text-color-2);
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/03addFriend.vue